"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CalorieCount = exports.resolveDiffSign = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const NutritionWeekFact_1 = __importDefault(require("./NutritionWeekFact"));
const typography_1 = require("../../shared/typography");
const hooks_1 = require("../../shared/hooks");
const utils_1 = require("../../molecules/progress/utils");
const resolveDiffSign = (diff) => {
    if (diff > 0)
        return `+${diff}`;
    return diff.toString();
};
exports.resolveDiffSign = resolveDiffSign;
const resolveMobileCalories = (value, label, status, diff, budget) => {
    const hasBudget = budget && budget !== 0;
    return ((0, jsx_runtime_1.jsxs)(typography_1.P, { children: [value, (0, jsx_runtime_1.jsxs)("span", { children: ["\u00A0", label] }, void 0), hasBudget && ((0, jsx_runtime_1.jsxs)(ColoredText, { color: (0, utils_1.resolveColor)(status), children: ["\u00A0", diff] }, void 0))] }, void 0));
};
const resolveWebFactWithDiff = (value, diff, status, budget, unit) => {
    const hasBudget = budget && budget !== 0;
    return ((0, jsx_runtime_1.jsxs)(typography_1.P, { children: [Math.round(value), " ", unit, hasBudget && ((0, jsx_runtime_1.jsxs)(ColoredText, { color: (0, utils_1.resolveColor)(status), children: ["\u00A0", `${(0, exports.resolveDiffSign)(Math.round(diff))}`] }, void 0))] }, value));
};
const resolveCalories = (value, label, diff, status, budget, isMobile) => {
    if (isMobile) {
        return resolveMobileCalories(value, label, status, diff, budget);
    }
    return resolveWebFactWithDiff(value, diff, status, budget);
};
const resolveBudgetBasingOnDayType = (trainingValue, nonTrainingValue, dayType) => (dayType === "TRAINING" ? trainingValue : nonTrainingValue);
const CalorieCount = (props) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    const { isMobile } = (0, hooks_1.useRWD)();
    // TODO: Rewrite
    return ((0, jsx_runtime_1.jsx)(Wrapper, { children: props.calorieBudgetInfo && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(NutritionWeekFact_1.default, { value: resolveCalories(props.nutritionFacts.calories, props.translations.kcal, (_a = props.calorieBudgetInfo) === null || _a === void 0 ? void 0 : _a.calories.difference, (_b = props.calorieBudgetInfo) === null || _b === void 0 ? void 0 : _b.calories.status, props.hasCalorieBudget
                        ? resolveBudgetBasingOnDayType(props.calorieBudgetBundle.forTrainingDay.calories, props.calorieBudgetBundle.forNonTrainingDay.calories, props.dayType)
                        : 0, isMobile) }, void 0), (0, jsx_runtime_1.jsx)("div", { "data-cy": "nutrition-week-item-calorie", children: !isMobile && [
                        (0, jsx_runtime_1.jsx)(NutritionWeekFact_1.default, { value: resolveWebFactWithDiff(props.nutritionFacts.carbs, (_c = props.calorieBudgetInfo) === null || _c === void 0 ? void 0 : _c.carbs.difference, (_d = props.calorieBudgetInfo) === null || _d === void 0 ? void 0 : _d.carbs.status, props.hasCalorieBudget
                                ? resolveBudgetBasingOnDayType(props.calorieBudgetBundle.forTrainingDay.carbohydrates, props.calorieBudgetBundle.forNonTrainingDay
                                    .carbohydrates, props.dayType)
                                : 0, props.unit) }, props.translations.carbs),
                        (0, jsx_runtime_1.jsx)(NutritionWeekFact_1.default, { value: resolveWebFactWithDiff(props.nutritionFacts.protein, (_e = props.calorieBudgetInfo) === null || _e === void 0 ? void 0 : _e.protein.difference, (_f = props.calorieBudgetInfo) === null || _f === void 0 ? void 0 : _f.protein.status, props.hasCalorieBudget
                                ? resolveBudgetBasingOnDayType(props.calorieBudgetBundle.forTrainingDay.proteins, props.calorieBudgetBundle.forNonTrainingDay.proteins, props.dayType)
                                : 0, props.unit) }, props.translations.protein),
                        (0, jsx_runtime_1.jsx)(NutritionWeekFact_1.default, { value: resolveWebFactWithDiff(props.nutritionFacts.fats, (_g = props.calorieBudgetInfo) === null || _g === void 0 ? void 0 : _g.fats.difference, (_h = props.calorieBudgetInfo) === null || _h === void 0 ? void 0 : _h.fats.status, props.hasCalorieBudget
                                ? resolveBudgetBasingOnDayType(props.calorieBudgetBundle.forTrainingDay.fats, props.calorieBudgetBundle.forNonTrainingDay.fats, props.dayType)
                                : 0, props.unit) }, props.translations.fats),
                        (0, jsx_runtime_1.jsx)(NutritionWeekFact_1.default, { value: resolveWebFactWithDiff(props.nutritionFacts.fibers, (_j = props.calorieBudgetInfo) === null || _j === void 0 ? void 0 : _j.fibers.difference, (_k = props.calorieBudgetInfo) === null || _k === void 0 ? void 0 : _k.fibers.status, props.hasCalorieBudget
                                ? resolveBudgetBasingOnDayType(props.calorieBudgetBundle.forTrainingDay.fibers, props.calorieBudgetBundle.forNonTrainingDay.fibers, props.dayType)
                                : 0, props.unit) }, props.translations.fibers)
                    ] }, void 0)] }, void 0)) }, void 0));
};
exports.CalorieCount = CalorieCount;
const Wrapper = styled_components_1.default.div `
  display: flex;

  & > div:nth-of-type(2) {
    display: flex;
  }

  & > div:nth-of-type(2) > div {
    margin-left: ${({ theme }) => theme.spacings.s};
  }

  p {
    display: inline-flex;
    font-size: 0.875rem;
  }

  p span:first-of-type {
    text-transform: lowercase;
  }

  @media (max-width: ${({ theme }) => theme.utils.breakpoints.mobile}) {
    & > div:first-of-type {
      width: unset;
    }

    p {
      font-size: 1rem;
    }
  }
`;
const ColoredText = styled_components_1.default.span `
  color: ${({ color }) => color};
`;
//# sourceMappingURL=CalorieCount.js.map